<app-header headerText="Aprobación de Carta Compromiso Por Acciones"></app-header>
<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true>

    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon>assignment_ind</mat-icon>
            Aprobación Carta <br>Compromiso
        </ng-template>

        <div *ngIf="listSigned.length > 0 ; else notListSigned">
            <div class="row mt-4">
                <div class="col-md-12">
                    <mat-table [dataSource]="listSigned" matSort class="table border">
                          <!-- Checkbox Column -->
                          <ng-container matColumnDef="select">
                            <mat-header-cell *matHeaderCellDef>
                              <mat-checkbox (change)="$event ? masterToggle() : null"
                                            [checked]="selection.hasValue() && isAllSelected()"
                                            [indeterminate]="selection.hasValue() && !isAllSelected()">
                              </mat-checkbox>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                              <mat-checkbox (click)="$event.stopPropagation()"
                                            (change)="$event ? selection.toggle(row) : null"
                                            [checked]="selection.isSelected(row)">
                              </mat-checkbox>
                            </mat-cell>
                          </ng-container>
    
                        <ng-container matColumnDef="employeeNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Número De<br>Colaborador:</mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.employeeNumber}} </mat-cell>
                        </ng-container>
    
                        <ng-container matColumnDef="contributionAmount">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Contribución:</mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.contributionAmount }} </mat-cell>
                        </ng-container>
    
                        <ng-container matColumnDef="numberOfPayments">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Pagos:</mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.numberOfPayments }} </mat-cell>
                        </ng-container>
    
                        <ng-container matColumnDef="status">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Estatus:</mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.status }} </mat-cell>
                        </ng-container>
    
                        <ng-container matColumnDef="contractUrl" class="center-text">
                            <mat-header-cell *matHeaderCellDef><span>Descargar Carta</span></mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <button mat-icon-button color="primary"  (click)="downloadFile(element.contractUrl)">
                                    <mat-icon>cloud_download</mat-icon>
    
                                </button>
    
                            </mat-cell>
                        </ng-container>
    
                        <ng-container matColumnDef="accept" class="center-text">
                            <mat-header-cell *matHeaderCellDef><span>Aceptar</span></mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <button mat-icon-button style="color: green"   (click)="process(element.ssID, 'approved')">
                                    <mat-icon>done</mat-icon>
                                </button>
    
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="declined" class="center-text">
                            <mat-header-cell *matHeaderCellDef><span>Rechazar</span></mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <button mat-icon-button danger  style="color: red;" (click)="process(element.ssID, 'declined')">
                                    <mat-icon>clear</mat-icon>
                                </button>
    
                            </mat-cell>
                        </ng-container>
    
    
                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    
                    </mat-table>
                </div>

            </div>
            <div class="row mt-4 justify-content-center" *ngIf="selection.selected.length > 0">
                <div class="col-xl-4 col-md-4 col-sm-6">
                    <button class="btn btn-block btn-primary" (click)="fullApproved()">Aprobar Empleados</button>
                </div>
            </div>

        </div>
        <ng-template #notListSigned>

            <div class="row mt-4" *ngIf="!listSigned.length">
                <div class="col-md-12 text-center noActions">
                    <mat-icon aria-hidden="true">spellcheck</mat-icon>
                    <h5>No Hay Cartas Compromiso por Revisar</h5>
                </div>
            </div>

        </ng-template>


    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon>recent_actors</mat-icon>
            Colaboradores <br>en Proceso
        </ng-template>

        <div class="row mt-4" *ngIf="listFilled.length > 0 ; else notListFilled">

            <div class="col-md-12">

                <mat-table [dataSource]="listFilled" matSort class="table border">

                    <ng-container matColumnDef="employeeNumber">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Número De<br>Colaborador:</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.employeeNumber}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="contributionAmount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Contribución:</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.contributionAmount }} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="numberOfPayments">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Pagos:</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.numberOfPayments }} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Estatus:</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.status }} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="contractUrl" class="center-text">
                        <mat-header-cell *matHeaderCellDef><span>Descargar Carta</span></mat-header-cell>
                        <mat-cell *matCellDef="let element">

                            <button mat-icon-button color="primary"  (click)="downloadFile(element.contractUrl)">
                                <mat-icon>cloud_download</mat-icon>
                            </button>

                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="declined" class="center-text">
                        <mat-header-cell *matHeaderCellDef><span>Rechazar</span></mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <button mat-icon-button danger  style="color: red;" (click)="process(element.ssID, 'declined')">
                                <mat-icon>clear</mat-icon>
                            </button>

                        </mat-cell>
                    </ng-container>


                    <mat-header-row *matHeaderRowDef="consultColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: consultColumns;"></mat-row>

                </mat-table>

            </div>

        </div>
        <ng-template #notListFilled>

            <div class="row mt-4" *ngIf="!listFilled.length">
                <div class="col-md-12 text-center noActions">
                    <mat-icon aria-hidden="true">spellcheck</mat-icon>
                    <h5>No Hay Colaboradores en Proceso</h5>
                </div>
            </div>

        </ng-template>


    </mat-tab>


</mat-tab-group>